import { Location } from '../../components/shared/LocationFinder/types';
import getCityStateZipFromFormattedAddress from './getCityStateZipFromFormattedAddress';

const getLocationFromPlace = (placeDetails: any) => {
  const { lat, lng } = placeDetails.result.geometry.location;
  const location: Location = {
    place_id: placeDetails.result.place_id,
    coordinates: [lng, lat],
  };
  const zipcode =
    placeDetails.result.address_components.find(
      (comp: { long_name: string; short_name: string; types: string[] }) =>
        comp.types.includes('postal_code'),
    )?.short_name || '';

  const zipcodeLocation = getCityStateZipFromFormattedAddress(
    placeDetails.result.formatted_address,
  );

  return { location, zipcode, zipcodeLocation };
};

export default getLocationFromPlace;
